module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Delat till:":"Shared to:","Meddelande:":"Message:","Du":"You","skrevs":"Wrote"},"sv":{"Delat till:":"Delat till:","Meddelande:":"Meddelande:","Du":"Du","skrevs":"skrevs"}}')
  delete Component.options._Ctor
}
